module.exports = __webpack_public_path__ + "img/manage-empty-resume-file.46107967.svg";